import { render, staticRenderFns } from "./searchWords.vue?vue&type=template&id=593126e9&"
import script from "./searchWords.vue?vue&type=script&lang=js&"
export * from "./searchWords.vue?vue&type=script&lang=js&"
import style0 from "./searchWords.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports